var _path, _path2, _path3, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorCafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.67,30.565h-4.919c-4.473,0-8.263-3.293-8.888-7.722l-1.189-8.425h25.072l-1.189,8.425c-.625,4.429-4.415,7.722-8.888,7.722Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m33.055,16.542c2.498,0,4.524,2.025,4.524,4.524s-2.025,4.524-4.524,4.524c-.625,0-1.22-.127-1.761-.356"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4.421,35.384h31.58c0,2.167-1.759,3.927-3.927,3.927H8.347c-2.167,0-3.927-1.759-3.927-3.927h0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.468,
    y1: 9.58,
    x2: 14.468,
    y2: 5.571
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.82,
    y1: 9.58,
    x2: 25.82,
    y2: 5.571
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20.211,
    y1: 9.58,
    x2: 20.211,
    y2: 2.69
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorCafe);
export default __webpack_public_path__ + "static/media/indoor-cafe.3da70403efc88d5a4c5e1affa76fed36.svg";
export { ForwardRef as ReactComponent };